import { z } from 'zod';

import { schemaEuropacePlatform } from './EuropacePlatform';

export const schemaEuropacePlatforms = z.object({
    europace2: schemaEuropacePlatform,
    starpool: schemaEuropacePlatform,
});

export type SchemaEuropacePlatforms = z.infer<typeof schemaEuropacePlatforms>;
